import type { FunctionComponent } from "react";

import { StyledVideoRecorder, VideoTitle, VideoTitleContainer } from "./styles";

export type Props = {
  className?: string;
  isHeroVideo?: boolean;
  title?: string;
};

export const SCMPYouTubeVideoFooter: FunctionComponent<Props> = ({
  className,
  isHeroVideo,
  title,
}) => {
  if (!title) return null;
  return (
    <VideoTitleContainer $isHeroVideo={isHeroVideo} className={className}>
      <StyledVideoRecorder />
      <VideoTitle>{title}</VideoTitle>
    </VideoTitleContainer>
  );
};

SCMPYouTubeVideoFooter.displayName = "SCMPYouTubeVideoFooter";
